module.exports = __webpack_public_path__ + "img/nursing_skills.63e5a040.svg";